<template>
  <div>
    <fieldset>
      <legend
        class="block text-sm font-medium leading-5 text-gray-700 mb-1"
        v-if="label"
      >
        {{ label }}
      </legend>
      <div class="bg-white rounded-md shadow-sm">
        <div class="flex">
          <div class="w-4/12 flex-auto min-w-0">
            <input
              aria-label="Day"
              class="form-input relative block w-full rounded-none rounded-l-md bg-transparent focus:z-10 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
              :class="inputClass"
              type="text"
              :placeholder="$t('birthday_day_placeholder')"
              maxlength="2"
              :value="day"
              @change="daySet($event.target.value)"
              :disabled="disabled"
            />
          </div>
          <div class="-ml-px w-4/12 flex-auto min-w-0">
            <input
              aria-label="Month"
              class="form-input relative block w-full rounded-none bg-transparent focus:z-10 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
              :class="inputClass"
              type="text"
              :placeholder="$t('birthday_month_placeholder')"
              maxlength="2"
              :value="month"
              @change="monthSet($event.target.value)"
              :disabled="disabled"
            />
          </div>
          <div class="-ml-px flex-auto min-w-0">
            <input
              aria-label="Year"
              class="form-input relative block w-full rounded-none rounded-r-md bg-transparent focus:z-10 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
              :class="inputClass"
              type="text"
              :placeholder="$t('birthday_year_placeholder')"
              maxlength="4"
              :value="year"
              @change="yearSet($event.target.value)"
              :disabled="disabled"
            />
          </div>
        </div>
      </div>
    </fieldset>
    <slot name="invalid" v-if="v && v.$error">
      <p
        class="mt-1 text-xs text-red-600"
        v-if="v.$params.required && !v.required"
      >
        {{ label }} is required.
      </p>
      <p
        class="mt-1 text-xs text-red-600"
        v-if="v.$params.isodate && !v.isodate"
      >
        {{ label }} is invalid.
      </p>
    </slot>
  </div>
</template>

<style lang="postcss" scoped>
input.form-input.valid,
textarea.form-input.valid,
select.form-select.valid {
  @apply border-green-400 text-green-900;
}
input.form-input.invalid,
textarea.form-input.invalid,
select.form-select.invalid {
  @apply border-red-400 text-red-900; /* placeholder-red-300 */
}
</style>

<script>
import input from './SqrInput.js';

export default {
  name: 'SqrInputDateNum',
  mixins: [input],
  props: {
    disabled: Boolean,
  },
  computed: {
    day() {
      if (!this.value) return '';
      const parts = this.value.split('-');
      return parts.length > 1 && parts[2];
    },
    month() {
      if (!this.value) return '';
      const parts = this.value.split('-');
      return parts.length > 1 && parts[1];
    },
    year() {
      return this.value && this.value.split('-')[0];
    },
  },
  methods: {
    yearSet(year) {
      year = year.padStart(4, '0');
      const current = this.value || '';
      let parts = current.split('-');
      while (parts.length < 2) parts.push('');
      const date = [year, parts[1], parts[2]].join('-');
      this.$emit('change', date);
    },
    monthSet(month) {
      month = month.padStart(2, '0');
      const current = this.value || '';
      let parts = current.split('-');
      while (parts.length < 2) parts.push('');
      const date = [parts[0], month, parts[2]].join('-');
      this.$emit('change', date);
    },
    daySet(day) {
      day = day.padStart(2, '0');
      const current = this.value || '';
      let parts = current.split('-');
      while (parts.length < 2) parts.push('');
      const date = [parts[0], parts[1], day].join('-');
      this.$emit('change', date);
    },
  },
};
</script>
